import { render, staticRenderFns } from "./AnomaliesPage.vue?vue&type=template&id=1c321a19&"
import script from "./AnomaliesPage.vue?vue&type=script&lang=js&"
export * from "./AnomaliesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports